/**
 * Formats a timestamp string into a relative time string (e.g., "2 hours ago")
 * @param timestamp - ISO 8601 timestamp string
 * @returns Formatted relative time string
 */
export function formatTimestamp(timestamp: string): string {
  const dateObj = new Date(timestamp);
  const now = new Date();
  const nowUtc = new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
  );

  const diff = nowUtc.getTime() - dateObj.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(seconds / 3600);
  const days = Math.floor(seconds / 86400);
  const weeks = Math.floor(seconds / 604800);
  const months = Math.floor(seconds / 2629800);
  const years = Math.floor(seconds / 31557600);

  if (seconds < 60) {
    return seconds <= 5
      ? 'now'
      : `${seconds} ${seconds === 1 ? 'second' : 'seconds'} ago`;
  } else if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  } else if (hours < 24) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  } else if (days < 7) {
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  } else if (weeks < 4 && weeks > 0) {
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
  } else if (months < 12 && months > 0) {
    return `${months} ${months === 1 ? 'month' : 'months'} ago`;
  } else if (years > 0) {
    return `${years} ${years === 1 ? 'year' : 'years'} ago`;
  } else {
    // Fallback for edge cases where calculated values are 0
    if (days >= 7) {
      const fallbackWeeks = Math.max(1, weeks);
      return `${fallbackWeeks} ${fallbackWeeks === 1 ? 'week' : 'weeks'} ago`;
    } else if (weeks >= 4) {
      const fallbackMonths = Math.max(1, months);
      return `${fallbackMonths} ${
        fallbackMonths === 1 ? 'month' : 'months'
      } ago`;
    } else {
      return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    }
  }
}
